import axios from 'axios'
import { nextAvailableDate, getHolidays, formatDate, timestamp, isGoogleEventsReady, getClientID, dataLayerPush } from '@/utilities.js'
import { generateReCaptchaToken } from '../../utilities'

const parseArray = arr => {
  return arr.reduce((acc, i) => {
    if (acc) {
      acc = `${acc}, ${i}`
      return acc
    }

    acc = i
    return acc
  }, '')
}

export default {
  namespaced: true,
  state: () => ({
    sizes: {
      10: { lowestPrice: '???.??' },
      15: { lowestPrice: '???.??' }
    },
    pricingModel: '',
    makoResponse: null,
    selectedDumpster: null,
    selectedDumpsterSize: '10',
    dumpstersInSizeGroup: [],
    lowestPricedDumpsterPrice: '',
    noService: false,
    holidays: [],
    showSearchingModal: false
  }),
  actions: {
    async callMako ({ commit, state }, payload) {
      const { selectedProjectType, selectedDebrisType, selectedFillType, lat, lng, address, city, province, zip } = payload
      const debrisType = parseArray(selectedDebrisType)

      dataLayerPush({ event: 'ecom-dumpster-search', selectedProjectType, selectedDebrisType: selectedDebrisType.join(','), selectedFillType })
      if (isGoogleEventsReady()) {
        const time = timestamp()
        window.gtag('event', 'Ecommerce - DumpsterSearch', {
          event_category: 'Ecommerce',
          event_label: `${time}~${window.location.href}~${selectedProjectType}~${debrisType}~${selectedFillType}`,
          send_to: process.env.VUE_APP_UA_ID
        })

        window.gtag('event', 'Ecommerce - DumpsterSearch', {
          event_category: 'Ecommerce',
          timestamp: time,
          project_type: selectedProjectType,
          debris_type: debrisType,
          fill_type: selectedFillType,
          bd_client_id: getClientID(),
          send_to: process.env.VUE_APP_GA4_ID
        })
      }

      const reCaptchaToken = await generateReCaptchaToken('SEARCH_PRODUCTS')
      const makoParams = {
        latitude: lat,
        longitude: lng,
        fillType: selectedFillType,
        projectType: selectedProjectType,
        debrisType: selectedDebrisType,
        address,
        city,
        state: province,
        zip_code: zip,
        includeMustCall: 1,
        reCaptchaToken
      }

      // TODO: replace this with hubRequest from utilities.js
      return axios.post(`${process.env.VUE_APP_SERVER}/api/getDumpsterList`, makoParams)
        .then(({ data }) => {
          // Reset noService state
          commit('noService', false)
          commit('pricingModel', data.meta.pricingModel)
          commit('sizes', data.meta.sizes) // Object of essential data for each size (currenly just lowest price)
          if (data.products.length) {
            const products = data.products.map(productSizeGroup => {
              // Check for sell as dumpsters and replace the actual volume with sell as volume
              return productSizeGroup.map(p => {
                // TODO: Delete this after LPP live for 14 days
                if (p.sellAsSize && data.meta.pricingModel !== 'LPP') {
                  // TODO: After LPP live for 14days come back and do this on the hub side
                  p.size = p.sellAsSize.replace(/Yard/g, '').trim()
                }
                // get next available date
                p.nextAvailableDate = nextAvailableDate(p, state.holidays)
                return p
              })
            })
            commit('noService', false)
            return commit('makoResponse', products)
          }
          // No results were returned, display no service modal
          commit('noService', true)
        })
        .catch((error) => {
          dataLayerPush({ event: 'ecom-mako-error', makoError: error })
          if (isGoogleEventsReady()) {
            const time = timestamp()
            window.gtag('event', 'Ecommerce - MAKOError', {
              event_category: 'Ecommerce',
              event_label: `${time}~${window.location.href}`,
              send_to: process.env.VUE_APP_UA_ID
            })

            window.gtag('event', 'Ecommerce - MAKOError', {
              event_category: 'Ecommerce',
              timestamp: time,
              bd_client_id: getClientID(),
              send_to: process.env.VUE_APP_GA4_ID
            })
          }
        })
    },
    holidays ({ state }) {
      getHolidays().then(result => {
        if (result.length) {
          result.map(holiday => state.holidays.push(formatDate(holiday.start)))
        }
      })
    }
  },
  getters: {
    // datesUnavailable (state) {
    //   const datesUnavailable = state.selectedDumpster.datesUnavailable.map(date => {
    //     return new Date(`${date}T00:00:00`)
    //   })
    //   return [...datesUnavailable, ...state.holidays]
    // },
    isContinueDisabled (state, getters, rootState) {
      if (rootState.cart.item) { return false }
      return true
    }
    // minDeliveryDate (state, getters, rootState) {
    //   const deliveryDate = new Date(`${rootState.dumpster.selectedDumpster.deliveryDate}T00:00:00`)
    //   const currentDate = new Date()
    //   currentDate.setHours(0, 0, 0, 0)
    //   const datesUnavailable = rootState.dumpster.selectedDumpster.datesUnavailable.map(date => {
    //     return new Date(`${date}T00:00:00`)
    //   })

    //   const isDateUnavailable = () => {
    //     if ((isBefore(deliveryDate, currentDate))) {
    //       return true
    //     } else {
    //       return datesUnavailable.find(item => item.getTime() === deliveryDate.getTime())
    //     }
    //   }
    //   // if the selected product delivery date is less than or equal to today, add a day
    //   while (isDateUnavailable()) {
    //     deliveryDate.setDate(deliveryDate.getDate() + 1)
    //   }
    //   return deliveryDate
    // }
  },
  mutations: {
    sizes (state, val) {
      state.sizes = val
    },
    pricingModel (state, val) {
      state.pricingModel = val
    },
    noService (state, val) {
      state.noService = val
    },
    setSelectedDumpsterSize (state, size) {
      state.selectedDumpsterSize = size
      const matchedSizeDumspters = state.makoResponse.reduce((acc, productSizeGroup) => {
        const matchingSizes = productSizeGroup.filter(p => p.size === state.selectedDumpsterSize)
        if (matchingSizes.length) acc = matchingSizes
        return acc
      }, [])
      const lowestPriceDumpster = matchedSizeDumspters.filter(p => p.isLowestPrice)[0]
      state.selectedDumpster = lowestPriceDumpster
      state.lowestPricedDumpsterPrice = lowestPriceDumpster.price
      state.dumpstersInSizeGroup = matchedSizeDumspters
    },
    setSelectedDumpster (state, dumpster) {
      state.selectedDumpster = dumpster
    },
    makoResponse (state, val) {
      // Patch for transitiong to LPP model, patches old saved carts, can be deleted 14 days after LPP launch
      if (val && !val[0][0] && val[0].price) {
        state.makoResponse = val.reduce((acc, product) => {
          product.isLowestPrice = true
          acc = [...acc, [product]]
          return acc
        }, [])
      } else {
        // Is a LPP response model
        state.makoResponse = val
      }
      if (state.makoResponse?.[0].length) {
        state.selectedDumpster = state.makoResponse[0][0]

        const matchedSizeDumspters = state.makoResponse.reduce((acc, productSizeGroup) => {
          const matchingSizes = productSizeGroup.filter(p => p.size === state.selectedDumpster.size)
          if (matchingSizes.length) acc = matchingSizes
          return acc
        }, [])
        const lowestPriceDumpster = matchedSizeDumspters.filter(p => p.isLowestPrice)[0]
        state.selectedDumpster = lowestPriceDumpster

        //  This is necessary to reset the setSelectedDumpsterSize if a search is rerun (ECOM-168)
        this.commit('dumpster/setSelectedDumpsterSize', lowestPriceDumpster.size)

        if (lowestPriceDumpster) {
          state.lowestPricedDumpsterPrice = lowestPriceDumpster.price
        }
        state.dumpstersInSizeGroup = matchedSizeDumspters
      }
    },
    showSearchingModal (state, val) {
      state.showSearchingModal = val
    }
  }
}
